<script lang="ts">
    import {
        partner1,
        partner3,
        partner4,
        partner5,
        partner6,
        partner7,
        partner8,
        partner9,
        partner10,
        partner11,
    } from "../assets/partners/index.js";

    const partners: Array<{
        title: string;
        href: string;
        image: string;
    }> = [
        {
            title: "Asociace autoškol",
            href: "https://www.asociaceautoskol.cz/",
            image: partner1,
        },
        {
            title: "Ministerstvo dopravy ČR",
            href: "https://www.mdcr.cz/",
            image: partner3,
        },
        {
            title: "Policie ČR",
            href: "https://www.policie.cz/",
            image: partner4,
        },
        {
            title: "Tým silniční bezpečnosti",
            href: "https://www.tymbezpecnosti.cz/",
            image: partner5,
        },
        {
            title: "Platforma vize 0",
            href: "https://www.platformavize0.cz/",
            image: partner6,
        },
        {
            title: "Autoklub ČR",
            href: "https://www.autoklub.cz/",
            image: partner7,
        },
        {
            title: "Besip",
            href: "https://besip.cz/",
            image: partner8,
        },
        {
            title: "Asociace center bezpečné jízdy",
            href: "https://www.asociacecenter.cz/home.html",
            image: partner9,
        },
        {
            title: "Autoškolský ombudsman",
            href: "https://www.autoskolsky-ombudsman.cz/",
            image: partner10,
        },
        {
            title: "Asociace školských psychologů",
            href: "https://www.dopravnipsychologovecr.cz/",
            image: partner11,
        },
    ];
</script>


    <section class="bg-gray-100">
        <div class="container mx-auto py-20">
            <h2 class="sr-only">Partneři</h2>

            <nav>
                <ul class="grid grid-cols-2 gap-x-8 gap-y-14 md:grid-cols-3 lg:grid-cols-5">
                    {#each partners as partner, index (index)}
                        <li class="grid place-items-center last:col-end-3 last:lg:col-auto">
                            <a href={partner.href} target="_blank" class="group">
                                <img
                                    alt={partner.title}
                                    src={partner.image}
                                    class="h-14 brightness-75 group-hover:brightness-50"
                                />
                            </a>
                        </li>
                    {/each}
                </ul>
            </nav>
        </div>
    </section>

